module.exports = __webpack_public_path__ + "static/media/funder-right.b1838dbf.jpg";